import styled from 'styled-components';
import { MonthlyPriceLabelStyled } from '../MonthlyPriceLabelStyled';

export const MonthlyPriceLabelStyledOV = styled(MonthlyPriceLabelStyled)`
  
`;
